import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button
} from '@mui/material';
import { walletAPI } from '../services/api';

const formatDate = (d) => d ? new Date(d).toLocaleDateString() : '—';

export default function Documents() {
  const navigate = useNavigate();
  const [policies, setPolicies] = useState([]);
  const [docsByPolicy, setDocsByPolicy] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const list = await walletAPI.listPolicies();
        const arr = Array.isArray(list) ? list : (list?.data ?? []);
        setPolicies(arr);
        const byPolicy = {};
        for (const p of arr) {
          try {
            const d = await walletAPI.getDocuments(p.id);
            const docs = Array.isArray(d) ? d : (d?.data ?? []);
            byPolicy[p.id] = { policy: p, documents: docs };
          } catch (_) {
            byPolicy[p.id] = { policy: p, documents: [] };
          }
        }
        setDocsByPolicy(byPolicy);
      } catch (e) {
        console.warn(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <Container sx={{ py: 3 }}><Typography>Loading…</Typography></Container>;

  const allDocs = [];
  Object.entries(docsByPolicy).forEach(([policyId, { policy, documents }]) => {
    documents.forEach((doc) => allDocs.push({ ...doc, policyName: policy.policy_name || policy.policy_type }));
  });

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>Document Vault</Typography>
      {allDocs.length === 0 ? (
        <Typography color="textSecondary">No documents. Upload from policy details.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Policy</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Uploaded</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allDocs.map((doc) => (
                <TableRow key={doc.id}>
                  <TableCell>{doc.policyName}</TableCell>
                  <TableCell>{doc.document_type}</TableCell>
                  <TableCell>{doc.document_name}</TableCell>
                  <TableCell>{formatDate(doc.upload_date)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Button sx={{ mt: 2 }} onClick={() => navigate('/wallet')}>Back to Wallet</Button>
    </Container>
  );
}
